import ZAction from './ZAction';


export default window.ZForms.registerClass('action.button', class ZButtonAction extends ZAction {
  constructor() {
    super(...arguments);
    this.viewPos = 'top_left';
  }

  _updateParamsFromRaw(rawData) {
    super._updateParamsFromRaw(rawData);
    this.viewPos = rawData.view_pos ? rawData.view_pos : this.viewPos;
  }
});
